import { reactive, readonly } from 'vue'

// Détection d'une nouvelle version déployée. Le cache navigateur reste actif : on compare
// simplement le fichier d'entrée chargé par cet onglet (nom hashé par Vite) avec celui
// que le serveur annonce. S'ils diffèrent, la page est rechargée (au prochain changement
// de page, ou via le bouton de la bannière) : le navigateur ne retélécharge alors que les
// fichiers dont le hash a changé, le reste vient du cache.
const ENDPOINT = '/api/system/version'
const POLL_INTERVAL_MS = 60000
const RELOAD_GUARD_KEY = 'porteo:update-reload-at'
const RELOAD_GUARD_MS = 30000

const state = reactive({ updateAvailable: false })

let started = false
let inflight = false

// Nom du fichier d'entrée chargé par cet onglet (null en dev : pas de hash, on ne fait rien)
function loadedBuild() {
  const el = document.querySelector('script[type="module"][src*="/build/assets/app-"]')
  if (!el) return null
  return new URL(el.src, window.location.href).pathname.replace(/^.*\/build\//, '')
}

async function check() {
  if (inflight || state.updateAvailable) return
  const current = loadedBuild()
  if (!current) return
  inflight = true
  try {
    const res = await fetch(ENDPOINT, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
    if (!res.ok) return
    const { build } = await res.json()
    if (build && build !== current) state.updateAvailable = true
  } catch {
    // Réseau indisponible : nouvel essai au prochain tour
  } finally {
    inflight = false
  }
}

// Recharge la page, avec un garde-fou contre toute boucle de rechargement
export function reloadForUpdate(targetUrl) {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0)
    if (Date.now() - last < RELOAD_GUARD_MS) return false
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  } catch {
    // sessionStorage indisponible : on recharge quand même
  }
  if (targetUrl) window.location.assign(targetUrl)
  else window.location.reload()
  return true
}

export function startUpdateWatcher() {
  if (started) return
  started = true
  setInterval(() => {
    if (document.visibilityState === 'visible') check()
  }, POLL_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check()
  })
  window.addEventListener('online', check)
  check()
}

export function useAppUpdate() {
  return { state: readonly(state), reload: () => reloadForUpdate() }
}
